//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {validateNull,validateEmail,validatePwd} from '../../utils/validate';
  import Xinput from '../../components/Xinput.vue';
  import Pinput from '../../components/Pinput.vue';
export default {
  name: 'init',
  data(){
    return{
      //col-12
      col3:"col-3",
      col4:"col-4",
      col5:"col-5",
      col6:"col-6",
      col8:"col-8",
      col9:"col-9",
      col12:"col-12",

      //cols-100
      cols22:"cols-22",
      cols78:"cols-78",

      //:disabled="btn_disabled
      btn_disabled:true,
      submit_btn_class:"btn btn-blue",
      check_value:true,

      //公司名
      cname:"",
      cname_msg:'',
      cname_name:'公司名<span class="label label-danger">*</span>',
      cname_class:"form-control",
      cname_Placeholder:"必填",
      cname_length:30,

      //職位
      job:"",
      job_msg:'',
      job_name:'职位<span class="label label-danger">*</span>',
      job_class:"form-control",
      job_Placeholder:"必填",
      job_length:20,

      //姓名
      name:"",
      name_msg:'',
      name_name:'姓名<span class="label label-danger">*</span>',
      name_class:"form-control",
      name_Placeholder:"必填",
      name_length:10,

      //邮箱
      email:"",
      email_msg:'',
      email_name:'邮箱',
      email_class:"form-control",
      email_Placeholder:"将获取更多产品信息",

      //密码
      pwd:"",
      pwd_msg:'',
      pwd_name:'密码<span class="label label-danger">*</span>',
      pwd_class:"form-control",
      pwd_Placeholder:"6-16位数字或字符组合",

      //
      type:{
        number:"number",
        text:"text",
        email:"email",
        passworld:"password",
      }
    }
  },
  created: function(){
    //初始化执行的方法
    this.code_value = this.$route.params.code_value;
    this.tel = this.$route.params.tel;
    this.cname = this.$route.params.cname;
    this.job = this.$route.params.job;
    this.name = this.$route.params.name;
    this.email = this.$route.params.email;

/*    console.log(
      "cname :"+ this.cname +
      "job :"+ this.job +
      "name :"+ this.name +
      "email :"+ this.email +
      "code_value :"+ this.code_value +
      "tel :"+ this.tel
      )
*/
    
    if(this.$route.params.email){
      this.email = this.$route.params.email;
    }else{
      this.email = "";
    }



  },
  components: {
    Pinput,Xinput
  },
  methods: {
    handleCname:function(str){
      this.cname = str;
      if(this.cname){
       if(!validateNull(this.cname)){
          this.cname_class = "form-control input-error"
          this.cname_msg = "公司名不能为空"; 
        }
        else{
          this.cname_msg = "";
          this.cname_class = "form-control"
        }
        this.doCheck();
      }
      this.doCheck();
    },
    handleJob:function(str){
      this.job = str;
      if(this.job){
        if(!validateNull(this.job)){
          this.job_class = "form-control input-error"
          this.job_msg = "职位不能为空"; 
        }
        else{
          this.job_msg = "";
          this.job_class = "form-control"
        }
        this.doCheck();
      }
      this.doCheck();
    },
    handleName:function(str){
      this.name = str;
        if(this.name){
        if(!validateNull(this.name)){
          this.name_class = "form-control input-error"
          this.name_msg = "姓名不能为空"; 
        }
        else{
          this.name_msg = "";
          this.name_class = "form-control"
        }
        this.doCheck();
      }
      this.doCheck();
    },
    handleEmail:function(str){
        this.email = str;
        if(this.email){
          if(!validateEmail(this.email)){
            this.email_class = "form-control input-error"
            this.email_msg = "邮件格式不对"; 
          }
          else{
             this.email_class = "form-control"
             this.email_msg = "";
          }
      }else{
         this.email_class = "form-control"
             this.email_msg = "";
        this.doCheck();
      }
    },
    handlePwd:function(str){

      this.pwd = str;
     if(this.pwd==""){
       this.pwd_class = "form-control"
            this.pwd_msg = "";
     }
     else{
      if(this.pwd){
        if(!validatePwd(this.pwd)){
            this.pwd_class = "form-control input-error"
            this.pwd_msg = "密码格式不对"; 
        }else{
            this.pwd_class = "form-control"
            this.pwd_msg = "";
        }
        this.doCheck();
      }else{
        this.pwd_class = "form-control"
        this.pwd_msg = "";
        this.doCheck();
      }
    }


    },
    handlePwd2:function(str){
        this.pwd = str;

        if(this.pwd.length >= "6"){
          if(!validatePwd(this.pwd)){
            this.pwd_class = "form-control input-error"
            this.pwd_msg = "密码格式不对"; 
          }else{
              this.pwd_class = "form-control"
              this.pwd_msg = "";
          }
        }
        this.doCheck();
      },
    goService:function(){

       this.$router.push({
        name: 'service',
        params: {
          cname: this.cname,
          job: this.job,
          name: this.name,
          email: this.email,
          code_value : this.code_value,
          tel : this.tel}
      })
    },
    back:function(){
      var tel = this.$route.params.tel;
 
      this.$router.push({
        name: 'register', 
        params: {tel:tel,}})
    },
    changeCheckbox:function(){
      

      if(this.check_value == false){
        this.check_value= true;
      }
      else{
        this.check_value= false;
      }
    },
    doCheck:function(){

       if(validateNull(this.cname) && validateNull(this.job) && validateNull(this.name) && (this.pwd.length >= 6 ) ){
          this.btn_disabled = false;
       }else{
          this.btn_disabled = true;
       }
    },
    dosubmit:function(){
     
      if(this.check_value == true){
        if(validateNull(this.cname) && validateNull(this.job) && validateNull(this.name) && validatePwd(this.pwd)){
          if(validateEmail(this.email) || this.email==""){

        
            var self = this;
            self.btn_disabled = true; 

            var tel = this.$route.params.tel;
            var captcha = this.$route.params.code_value;

          
           /* var url = this.HOST + "/json/global_register/initialize.action?loginName=" + tel + "&captcha=" + captcha + 
            "&password=" + self.pwd + "&app['company']=" + self.cname + "&app['title']=" + self.job + "&app['userName']=" + self.name + "&app['contact']=" + self.email ;  */       
            var url = "/json/global_register/initialize.action?loginName=" + tel + "&captcha=" + captcha + 
            "&password=" + self.pwd + "&app['company']=" + self.cname + "&app['title']=" + self.job + "&app['userName']=" + self.name + "&app['contact']=" + self.email ;         
              $.ajax({
                url,
                type: 'GET',
                timeout: 10000,
                error:function(){
                  self.$vux.toast.show({text:'连接超时',type:'text',time:4000})
                },
                success:function (responseText) {
                  
                  var status = responseText.status;
                  var statusText = responseText.statusText;

                  if (status == 0) {
                    self.$router.push({ name: 'exist', params: {tel:tel,} })}
                  else if(status == 101005){
                    self.$vux.toast.show({text:'验证码失效',type:'text',time:4000})
                    self.btn_disabled = false; 
                  }
                  else if(status == 101001 ){
                    self.$vux.toast.show({text:'验证码错误',type:'text',time:4000})
                    self.btn_disabled = false; 
                  }
                  else if(status == 100000 ){
                    self.$vux.toast.show({text:'手机号或验证码为空',type:'text',time:4000})
                    self.btn_disabled = false; 
                  }
                }})
                }
                else {

                  this.handleEmail(this.email);
                }}

        else{
          this.handleCname(this.cname);
          this.handleJob(this.job);
          this.handleName(this.name);
          this.handleEmail(this.email);
        }
      }
      else{
        this.$vux.toast.show({text:'请仔细阅读使用条款',type:'text',time:4000})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/init/index.vue